import { request } from '@umijs/max';

// 检查微信绑定状态
export async function checkWechatBindingStatus() {
  return request('/api/wechat-binding/status', {
    method: 'GET',
  });
}

// 生成微信绑定二维码（已废弃，保留用于兼容）
export async function generateWechatBindQrCode() {
  return request('/api/wechat-binding/qr-code', {
    method: 'POST',
  });
}

// 生成微信OAuth授权URL
export async function generateWechatAuthUrl() {
  return request('/api/wechat-binding/auth-url', {
    method: 'GET',
  });
}

// 绑定微信账号
export async function bindWechat(data: {
  openid: string;
  nickname: string;
  avatar: string;
}) {
  return request('/api/wechat-binding/bind', {
    method: 'POST',
    data,
  });
}

// 解绑微信账号
export async function unbindWechat() {
  return request('/api/wechat-binding/unbind', {
    method: 'POST',
  });
}

// 获取授权页面信息（公开接口，无需登录）
export async function getAuthorizePageInfo(params?: {
  openid?: string;
  nickname?: string;
  avatar?: string;
  error?: string;
}) {
  return request('/api/wechat-binding/authorize-page', {
    method: 'GET',
    params,
    skipErrorHandler: true, // 公开接口，跳过错误处理
  });
}

// 通过openid绑定用户（公开接口，无需登录）
export async function bindByOpenid(params: {
  openid: string;
  username?: string;
  user_id?: number;
  bind_token?: string;
  nickname?: string;
  avatar?: string;
}) {
  return request('/api/wechat-binding/bind-by-openid', {
    method: 'GET',
    params,
    skipErrorHandler: true, // 公开接口，跳过错误处理
  });
}
